
// src/helpers/html-parse-dom.js

import { parseDOM } from 'htmlparser2'
export default parseDOM



// WEBPACK FOOTER //
// ./src/helpers/html-parse-dom.js